var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["TelemetryEventType"]: () => (__WEBPACK_EXTERNAL_MODULE__corbado_shared_util_e31171fe__.TelemetryEventType), ["sendEvent"]: () => (__WEBPACK_EXTERNAL_MODULE__corbado_shared_util_e31171fe__.sendEvent) });